/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_cat_faq1_a = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enter your value, select the unit you're converting from and the unit you want, and the ${i?.category} result appears immediately — no button to press.`)
};

const es_uc_cat_faq1_a = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ingresa tu valor, selecciona la unidad de la que estás convirtiendo y la unidad que deseas, y el resultado de ${i?.category} aparece inmediatamente — no hay botón que presionar.`)
};

const de_uc_cat_faq1_a = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Geben Sie Ihren Wert ein, wählen Sie die Ausgangseinheit und die gewünschte Zieleinheit, und das ${i?.category}-Ergebnis erscheint sofort — ohne einen Button zu drücken.`)
};

const nl_uc_cat_faq1_a = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Voer uw waarde in, selecteer de eenheid waar u van converteert en de eenheid die u wilt, en het ${i?.category} resultaat verschijnt direct — geen knop om in te drukken.`)
};

const fr_uc_cat_faq1_a = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Entrez votre valeur, sélectionnez l'unité à partir de laquelle vous convertissez et l'unité que vous souhaitez, et le résultat ${i?.category} s'affiche immédiatement — pas besoin d'appuyer sur un bouton.`)
};

const it_uc_cat_faq1_a = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Immetti il tuo valore, seleziona l'unità da cui stai convertendo e l'unità desiderata, e il risultato di ${i?.category} appare immediatamente — nessun pulsante da premere.`)
};

const pt_br2_uc_cat_faq1_a = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Digite seu valor, selecione a unidade que você está convertendo e a unidade que deseja, e o resultado de ${i?.category} aparece imediatamente — sem botão para pressionar.`)
};

const pt_uc_cat_faq1_a = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Introduza o seu valor, seleccione a unidade a partir da qual está a converter e a unidade que pretende, e o resultado de ${i?.category} aparece imediatamente — sem botão a clicar.`)
};

const ja_uc_cat_faq1_a = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`値を入力し、変換元の単位と変換先の単位を選択すると、${i?.category}の結果がすぐに表示されます — ボタンを押す必要はありません。`)
};

const zh_uc_cat_faq1_a = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[pending translation]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ category: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_cat_faq1_a = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_cat_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_cat_faq1_a", locale)
	if (locale === "en") return en_uc_cat_faq1_a(inputs)
	if (locale === "es") return es_uc_cat_faq1_a(inputs)
	if (locale === "de") return de_uc_cat_faq1_a(inputs)
	if (locale === "nl") return nl_uc_cat_faq1_a(inputs)
	if (locale === "fr") return fr_uc_cat_faq1_a(inputs)
	if (locale === "it") return it_uc_cat_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_uc_cat_faq1_a(inputs)
	if (locale === "pt") return pt_uc_cat_faq1_a(inputs)
	if (locale === "ja") return ja_uc_cat_faq1_a(inputs)
	return zh_uc_cat_faq1_a(inputs)
};